<template>
  <div class="main">
    <img class="bg-img" src="./images/bg.jpg" alt="" />
    <div class="action-box">
      <button class="btn-countdown">
        {{ countdown }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PreparatoryStage',
  data() {
    return {
      countdown: '',
      mInterval: null
    };
  },
  props: {
    startDate: {
      type: [Number, String]
    }
  },
  mounted() {
    this.startCountdown();
  },
  methods: {
    startCountdown() {
      this.mInterval = setInterval(() => {
        if (this.startDate) {
          const now = new Date().getTime();
          const targetDate = Number(this.startDate);
          const diff = targetDate - now;
          if (diff <= 0) {
            this.countdown = '我要投稿';
          }
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
          this.countdown = `距活動開始剩 ${days} 天 ${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
        }
      }, 1000);
    }
  },
  created() {},
  destroyed() {
    if (this.mInterval) {
      clearInterval(this.mInterval);
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 750px;
  flex: none;
  > .bg-img {
    width: 100%;
    max-width: 100%;
    margin-bottom: 206px;
  }
  .action-box {
    flex: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 256px;
    background: linear-gradient(180deg, rgba(3, 0, 46, 0) 0%, #03002e 22.62%);
    display: flex;
    align-items: center;
    justify-content: center;
    .btn-countdown {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 614px;
      height: 88px;
      background: rgba(255, 203, 70, 0.77);
      border-radius: 40px;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
      color: #2e2e2e;
    }
  }
}
</style>
